// App.js
import React from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import Dashboard from './components/Dashboard';
import SurveyEditor from './components/SurveyEditor';
import {useAuth} from './AuthContext';
import ProtectedRoute from "./ProtectedRoute";
import Login from "./components/Login";
import SurveyContainer from "./components/SurveyContainer";
import Sidebar from "./components/Sidebar";
import './App.css';
import SurveyAnalysis from "./components/SurveyAnalysis";
import SurveyCreateChat from './components/SurveyCreateChat'; // Import the new SurveyCreateChat component

function AppContent() {
    const { user, login, logout } = useAuth();
    const location = useLocation();
    
    // Check if we're on the survey page
    const isSurveyPage = location.pathname.startsWith('/survey/');

    return (
        <div className="app-container">
            {/* Conditionally render Sidebar - hide on survey pages */}
            {!isSurveyPage && <Sidebar user={user} logout={logout} />}

            {/* Main Content */}
            <div className={isSurveyPage ? "survey-full-width" : "flex-fill p-4"}>
                <Routes>
                    {user ? (
                        <Route path="/" element={<Dashboard />} />
                    ) : (
                        <Route path="/" element={<Login />} />
                    )}
                    <Route path="/create" element={<ProtectedRoute><SurveyEditor /></ProtectedRoute>} />
                    <Route path="/chat-create" element={<ProtectedRoute><SurveyCreateChat /></ProtectedRoute>} /> {/* New route for chat-based survey creation */}
                    <Route path="/configure/:id" element={<ProtectedRoute><SurveyEditor /></ProtectedRoute>} />
                    <Route path="/survey/:shortcode" element={<SurveyContainer/>}/>
                    <Route path="/analyze/:id" element={<ProtectedRoute><SurveyAnalysis /></ProtectedRoute>} />
                </Routes>
            </div>
        </div>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;